import accountStore from '@/stores/account.store'
import { MetadataKey } from '@/enums'

class WizardFlowService {
  public saveProgress(flowName: string, stepIndex: number): void {
    const metadata = accountStore.state.account.metadata
    const existing = metadata[MetadataKey.FLOWS]
    const flowProgress: Record<string, number> =
      existing && typeof existing === 'object' && !Array.isArray(existing)
        ? { ...existing }
        : {}
    flowProgress[flowName] = stepIndex

    accountStore
      .updateMetadata(MetadataKey.FLOWS, flowProgress)
      .catch((error) => {
        console.error('Failed to save wizard progress:', error)
      })
  }

  public getProgress(flowName: string): number | null {
    const metadata = accountStore.state.account.metadata
    const existing = metadata[MetadataKey.FLOWS]

    if (existing && typeof existing === 'object' && !Array.isArray(existing)) {
      const flowProgress = existing as Record<string, number>
      return flowProgress[flowName] ?? null
    }

    return null
  }
}

export default new WizardFlowService()
